import { createRouter, createWebHistory } from 'vue-router'
import { children } from './chlidren'
import store from '@/store/index'
const routes = [
  {
    path: '/',
    name: '/',
    redirect: '/home',
    component: () => import('@/views/index.vue'),
    children,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})
router.beforeEach((to, from, next) => {
  // 判断是否完善信息
  let inforStatus = localStorage.getItem('inforStatus')
  if (inforStatus != 1 && store.state.loging) {
    if (to.path == '/institutionStudent') {
      next()
    } else {
      next('/institutionStudent')
    }
  } else {
    next()
  }
})
export default router
